export default __webpack_public_path__ + "static/6844-c77301b9b2fe58b23aaf8b62b1f78670.jpg";